"use strict";

exports.__esModule = true;
exports.popoverPropTypes = void 0;

var _propTypes = require("prop-types");

var _constants = require("./constants");

var popoverPropTypes = {
  children: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.func]).isRequired,
  content: (0, _propTypes.oneOfType)([_propTypes.node, _propTypes.func]).isRequired,
  cursor: _propTypes.string,
  defaultIsOpen: _propTypes.bool,
  disabled: _propTypes.bool,
  focusTriggerOnClose: _propTypes.bool,
  hasArrow: _propTypes.bool,
  id: _propTypes.string,
  isOpen: _propTypes.bool,
  modifiers: _propTypes.object,
  onClose: _propTypes.func,
  onOpen: _propTypes.func,
  placement: (0, _propTypes.oneOf)(Object.keys(_constants.PLACEMENT)),
  positionFixed: _propTypes.bool,
  subtitle: _propTypes.node,
  title: _propTypes.node,
  triggerRef: _propTypes.func,
  usePortal: _propTypes.bool
};
exports.popoverPropTypes = popoverPropTypes;